import { ILocation } from "~/state/user/interfaces";

export function isWithinTenMinutes(timestamp: number): boolean {
	const tenMinutesInMs = 10 * 60 * 1000;
	const currentTime = Date.now();

	return (currentTime - timestamp) <= tenMinutesInMs;
}

export function isLocationUsable(location: ILocation): boolean {
	return location.source !== "none" && location.accuracy <= 1000 && isWithinTenMinutes(location.timestamp);
}
